import React from 'react'; 

import { Heading, Event } from '../../../components';
import { events } from '../../../constants';

  

const Events = () => {     
  
  const size = 3;   
  const topEvents = events.slice(0, size);

  return (
    <section className='events'>

      <Heading title={'Upcoming Events'} subTitle={'Join Our Events'} />

      <div className='box-container'>
      { 
        topEvents.map((event) => {  
          return(
            <Event key={event.id}  event={event} 
          />) 
        })
      }
      </div> 

    </section>
  )
}

export default Events;